// extracted by mini-css-extract-plugin
module.exports = {"stackItem":"StackItem_stackItem_2q5IJ"};